import { Injectable, computed, inject } from '@angular/core';
import { ReadonlyRepositoryListService } from '@softline/core';
import { Item, ItemPost } from '../models/item';
import { StockPostingQuery } from '../models/stock-posting-query';
import { ItemRepository } from '../repository/item.repository';
import { StockPostingService } from './stock-posting.service';

@Injectable()
export class ItemService extends ReadonlyRepositoryListService<
  Item,
  Item[],
  StockPostingQuery
> {
  private readonly stockPostingService = inject(StockPostingService);

  override params = computed(() => {
    return { id: this.stockPostingService.value()?.id ?? 0 };
  });

  constructor(protected override repository: ItemRepository) {
    super(repository);
  }
  protected override getItems(result: Item[] | null | undefined): Item[] {
    return result ?? [];
  }

  async addItem(item: ItemPost) {
    const newItem = (await this.repository.create(this.params().id, item)) as Item;

    const currentItems = this.value() ?? [];
    this.all.set([...currentItems, newItem]);
  }

  async updateItem(
    itemId: number,
    quantity: number,
    text: string,
    costCenterId?: number,
    generalLedgerAccountId?: number
  ) {
    const updatedItem = (await this.repository.patch(this.params().id, itemId, {
      quantity,
      text,
      ...(costCenterId !== undefined ? { costCenterId } : {}),
      ...(generalLedgerAccountId !== undefined ? { generalLedgerAccountId } : {}),
    })) as Item;

    const currentItems = this.value() ?? [];
    const updatedItems = currentItems.map((item) =>
      item.id === updatedItem.id ? updatedItem : item
    );

    this.all.set(updatedItems);
  }

  async deleteItem(itemId: number) {
    await this.repository.delete(this.params().id, itemId);
    const currentItems = this.value() ?? [];
    const updatedItems = currentItems.filter((item) => item.id !== itemId);

    this.all.set(updatedItems);
  }
}
